// src/components/PrivacyPolicy.js

import React from 'react';
import '../App.css';

function PrivacyPolicy() {
  return (
    <div style={{
      maxWidth: '860px',
      margin: '0 auto',
      padding: '48px 32px',
      color: '#e0e0e0',
      backgroundColor: '#1a1a1a',
      minHeight: '100vh',
      fontFamily: 'sans-serif',
      lineHeight: '1.8'
    }}>

      <div style={{ marginBottom: '40px' }}>
        <h1 style={{ color: '#ffffff', fontSize: '2rem', marginBottom: '8px' }}>
          Privacy Policy
        </h1>
        <p style={{ color: '#888', fontSize: '0.9rem' }}>
          Last updated: March 23, 2026
        </p>
      </div>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>1. Overview</h2>
        <p>
          RecertAgent is a professional building recertification documentation platform
          operated by Vilano Consulting LLC. This Privacy Policy explains how we collect,
          use, store, and protect information when you use our iOS application and web platform.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>2. Information We Collect</h2>

        <h3 style={subHeadingStyle}>Account Information</h3>
        <p>
          When you register, we collect your name, email address, firm name, professional
          license number, and phone number. This information is used to identify you as a
          licensed engineer and associate you with your projects.
        </p>

        <h3 style={subHeadingStyle}>Project Data</h3>
        <p>
          We collect building information, inspection dates, client names, property addresses,
          county information, and inspection notes that you enter during the course of your work.
        </p>

        <h3 style={subHeadingStyle}>Photos and Media</h3>
        <p>
          We collect photographs you take or upload using the app. Photos may contain embedded
          location metadata (EXIF data) based on your device settings. Photos are stored
          securely in Google Firebase Storage.
        </p>

        <h3 style={subHeadingStyle}>Location Information</h3>
        <p>
          With your permission, we collect location data to record the location of building
          inspection photographs. You can control location access through your device settings.
        </p>

        <h3 style={subHeadingStyle}>Device Information</h3>
        <p>
          We collect basic device information necessary for app functionality including device
          type and operating system version.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>3. How We Use Your Information</h2>
        <p>We use the information we collect to:</p>
        <ul style={listStyle}>
          <li>Provide and maintain the RecertAgent platform</li>
          <li>Associate inspection photographs with the correct project records</li>
          <li>Generate building recertification reports</li>
          <li>Authenticate your identity and secure your account</li>
          <li>Communicate with you about your account or projects</li>
        </ul>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>4. Data Storage and Security</h2>
        <p>
          All data is stored using Google Firebase, which provides enterprise-grade security
          including encryption at rest and in transit. Access to your data is restricted to
          authenticated users only. Project data is accessible only to the project owner and
          explicitly added project members.
        </p>
        <p>We implement the following security measures:</p>
        <ul style={listStyle}>
          <li>Email and password authentication with enforced complexity requirements</li>
          <li>Email enumeration protection</li>
          <li>Role-based access controls at the database level</li>
          <li>Secure HTTPS connections for all data transmission</li>
        </ul>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>5. Data Sharing</h2>
        <p>
          We do not sell, trade, or rent your personal information to third parties. We do
          not share your data with advertisers. Your data may be shared only in the following
          circumstances:
        </p>
        <ul style={listStyle}>
          <li>With project members you explicitly add to a project</li>
          <li>With service providers necessary to operate the platform (Google Firebase)</li>
          <li>If required by law or legal process</li>
        </ul>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>6. Data Retention</h2>
        <p>
          Your data is retained for as long as your account is active. You may request
          deletion of your account and associated data at any time by contacting us at the
          email below. Upon deletion, your personal information and project data will be
          permanently removed from our systems within 30 days.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>7. Your Rights</h2>
        <p>You have the right to:</p>
        <ul style={listStyle}>
          <li>Access the personal information we hold about you</li>
          <li>Correct inaccurate information</li>
          <li>Request deletion of your data</li>
          <li>Withdraw consent for location access at any time through your device settings</li>
        </ul>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>8. Children's Privacy</h2>
        <p>
          RecertAgent is intended for use by licensed professional engineers and is not
          directed at individuals under the age of 18. We do not knowingly collect personal
          information from minors.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>9. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy periodically. We will notify you of significant
          changes by updating the date at the top of this page. Continued use of the app
          after changes constitutes acceptance of the updated policy.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>10. Contact Us</h2>
        <p>
          If you have questions about this Privacy Policy or wish to exercise your data
          rights, please contact us at:
        </p>
        <div style={{
          marginTop: '16px',
          padding: '20px 24px',
          backgroundColor: '#242424',
          borderRadius: '8px',
          borderLeft: '3px solid #4a90e2'
        }}>
          <p style={{ margin: '4px 0' }}><strong>Vilano Consulting LLC</strong></p>
          <p style={{ margin: '4px 0' }}>
            Email:{' '}
            <a href="mailto:info@vilanoconsulting.com" style={{ color: '#4a90e2' }}>
              info@vilanoconsulting.com
            </a>
          </p>
          <p style={{ margin: '4px 0' }}>
            Website:{' '}
            <a href="https://www.recertagent.com" style={{ color: '#4a90e2' }}>
              www.recertagent.com
            </a>
          </p>
        </div>
      </section>

    </div>
  );
}

// Styles
const sectionStyle = {
  marginBottom: '36px',
  paddingBottom: '36px',
  borderBottom: '1px solid #2a2a2a'
};

const headingStyle = {
  color: '#ffffff',
  fontSize: '1.2rem',
  marginBottom: '12px',
  fontWeight: '600'
};

const subHeadingStyle = {
  color: '#cccccc',
  fontSize: '1rem',
  marginTop: '20px',
  marginBottom: '8px',
  fontWeight: '600'
};

const listStyle = {
  paddingLeft: '24px',
  marginTop: '8px',
  color: '#c0c0c0'
};

export default PrivacyPolicy;